
<template>
  <div class="header-container">
    <div class="header-content">
      <template v-if="isLogin">
        <div class="logo-box" @click="goto_home">
          <img
              class="logo"
              src="https://static.gaojidata.com/gaojidata/logo/new-title-blue.svg"
              alt=""
          />
          <span class="hidden">首页</span>
        </div>
      </template>
      <template v-else>
        <div class="logo-box" style="cursor: initial">
          <img
              class="logo"
              src="https://static.gaojidata.com/gaojidata/logo/new-title-blue.svg"
              alt=""
          />
        </div>
      </template>
      <div class="setting-box">
        <template v-if="isLogin">
          <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click" :key="'isLogin'">
            <div class="avatar-wrapper">
              <img src="@/assets/images/btn_Nav_account.png" class="user-avatar">
              <span class="userInfo">{{username}}</span>
              <i class="el-icon-caret-bottom" />
            </div>
            <el-dropdown-menu slot="dropdown">
<!--              <a href="javascript:void(0)" @click="opnePage('/profile')">
                <el-dropdown-item>个人中心</el-dropdown-item>
              </a>
              <el-dropdown-item divided @click.native="logout">
                <span style="display:block;">退出</span>
              </el-dropdown-item>-->

              <el-dropdown-item @click.native="reset">
                <span style="display:block;" class="action">重置密码</span>
              </el-dropdown-item>
              <el-dropdown-item @click.native="logout">
                <span style="display:block;" class="action">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <template v-else>
          <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click" :key="'isLoginout'">
            <div class="avatar-wrapper">
              <img src="@/assets/images/btn_Nav_account.png" class="user-avatar">
              <span class="userInfo" @click="login">登录</span>
              <el-dropdown-menu slot="dropdown"></el-dropdown-menu>
            </div>
          </el-dropdown>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';
import {setSessionStorage} from '@/utils/session'
export default {
  name: "",
  data() {
    return {
      username: this.$store.state.user.account,
      isShow: this.$store.state.display.isDisplay,
      isLogin: getToken()
		};
  },
	methods:{
    async logout() {
      // setSessionStorage('loginUrl','')
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login`)
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
		},
    async reset(){
      await this.$store.dispatch('user/logout')
      this.$router.push('/get_back_password')
    },
		goto_home() {
			if(location.href.indexOf('display') <= -1) {
        this.$router.push({path: '/'})
			}
    },
    opnePage(url){
      let href = location.href;
      let hash = location.hash;
      let openUrl = href.replace(hash, `#${url}`);
      window.open(openUrl);
    },
    async login(){
      this.$router.push(`/login`)
    }
	}
};
</script>

<style lang="scss" scoped>
.header-container{
  height: 100%;
  border-bottom: solid 1px #F0F0F2;
  .header-content {
    height: 100%;
    // position:relative;
    margin: 0 auto;
    width:1160px;
    display: flex;
    justify-content: space-between;
    // padding: 0 28px;
    border-bottom: solid 1px transparent;
    background: #ffffff;
    .logo-box {
      height: 100%;
      cursor: pointer;
      display: flex;
      align-items: center;
      .logo {
        height: 34px;
        // width: 90px;
        display: inline-block;
        //background: url('~@/assets/newLogo.png') no-repeat;
        //background-position: center center;
        //background-size: 100% auto;
      }
      span{
        margin-left: 20px;
        color: #7a7a7b;
        font-size: 16px;
        &.hidden{
          display: none;
        }
      }
    }
    .setting-box {
      display: flex;
      height: 100%;
      align-items: center;
      .el-dropdown{
        .avatar-wrapper{
          display: flex;
          align-items: center;
          cursor: pointer;
          .userInfo{
            margin: 0 2px 0 10px;
            font-size: 14px;
            color: #383838;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1366px){
  .header-container{
    .header-content {
      width: 85%;
    }
  }
}

.action{
  text-align: justify;
  text-align-last: justify;
  width: 56px;
}
</style>
